export default {
  "slots": {
    "root": "relative my-5 overflow-x-auto",
    "base": "w-full border-separate border-spacing-0 rounded-[calc(var(--ui-radius)*1.5)]"
  }
}